import {Component, OnInit} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../services/api-endpoints";
// removed legacy rxjs-compat operator import

@Component({ standalone: false, 
  selector: 'app-menu-list-join-servers',
  templateUrl: './menu-list-join-servers.component.html',
})
export class MenuListJoinServersComponent implements OnInit {

  private apiUrl = ApiEndpoints.GET_ALL_JOIN_SERVERS;
  list: any[];

  constructor(private http: HttpClient) {
    this.getServers();
    this.getData();
   }

  getData() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(this.apiUrl, "", options);
  }

  getServers() {
    this.getData().subscribe(list => {
      this.list = list
    })
  }

  ngOnInit() {
  }

}
